import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import { showConfirmModal } from '../../modules/modals/confirmService';
import {
  Alert,
  Col,
} from 'react-bootstrap';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';
import PaginationTable from '../../components/Pagination/PaginationTable';

@inject('dischargeStore')
@observer
class LoadSizeChargeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [],
      error: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onAdd = () => {
    this.setState({
      error: null,
    });
    this.props.dischargeStore.selectLoadSizeCharge(-1);
  };

  onEdit = id => {
    this.setState({
      error: null,
    });
    this.props.dischargeStore.selectLoadSizeCharge(id);
  };

  onRemove = id => {
    const { dischargeStore, t } = this.props;

    this.setState({
      error: null,
    });

    showConfirmModal({
      title: t('Do you want to remove charge?', {id}),
      okLabel: t('Yes'),
      cancelLabel: t('No'),
      enableEscape: false,
    }).then(() => {
      dischargeStore.removeLoadSizeCharge(id)
        .catch(e => {
          if (!this.mounted) {
            return;
          }
          this.setState({
            error: `${e.message}`,
          });
        });
    });
  };

  getColumns = () => {
    const { dischargeStore, t } = this.props;
    const { sorted } = this.state;

    return [
      {
        headerText: t('ID'),
        accessor: 'id',
        id: 'id',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Load Size'),
        accessor: 'loadSize',
        Cell: row => (`>= ${row.original.loadSize}`),
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Sequence'),
        accessor: 'dischargeSequenceId',
        Cell: row => (dischargeStore.getDischargeSequenceName(row.original.dischargeSequenceId)),
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Default Rate'),
        accessor: 'rate',
        id: 'rate',
        ...getSortHeaderProps(sorted),
      },
      {
        accessor: 'actions',
        maxWidth: 70,
        Cell: row => (
          <div className="text-right">
            <a className="btn btn-sm btn-default btn-action"
              title={t('Edit')}
              onClick={() => this.onEdit(row.original.id)}>
              <i className="fa fa-pencil"/>
            </a>
            <a className="btn btn-sm btn-default btn-action"
              title={t('Delete')}
              onClick={() => this.onRemove(row.original.id)}>
              <i className="fa fa-remove"/>
            </a>
          </div>
        ),
      },
    ];
  };

  render() {
    const { dischargeStore, t } = this.props;
    const { loadSizeCharge } = dischargeStore;

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{t('Load Size Charge')}</PortletCaption>
          {!loadSizeCharge.length && (
            <a className="btn btn-sm btn-default btn-action pull-right"
              title={t('Add')}
              onClick={this.onAdd}>
              <i className="fa fa-plus"/>
            </a>
          )}
        </PortletTitle>
        <PortletBody>
          {!!this.state.error && <Col sm={12}><Alert bsStyle="danger">{this.state.error}</Alert></Col>}
          <ReactTable
            className={'-highlight load-size-charge-table'}
            data={loadSizeCharge}
            columns={this.getColumns()}
            sorted={this.state.sorted}
            onSortedChange={sorted => this.setState({ sorted })}
            showPaginationTop={false}
            showPaginationBottom={true}
            showPageSizeOptions={true}
            PaginationComponent={PaginationTable}
            resizable={false}
            minRows={1}
            defaultPageSize={25}
          />
        </PortletBody>
      </Portlet>
    );
  };
}

export default withTranslation()(LoadSizeChargeList);
